import { FC } from 'react';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { QueryClient } from '@tanstack/react-query';

import { NotFoundPage } from '@/shared/not-found-page/not-found-page';
import { ErrorPage } from '@/shared/error-page/error-page';
import { PaymentCheckoutProvider } from '@/features/payment-session/public';

interface RouterContext {
  queryClient: QueryClient;
}

const RootLayout: FC = () => (
  <PaymentCheckoutProvider>
    <Outlet />
    <TanStackRouterDevtools />
  </PaymentCheckoutProvider>
);

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  errorComponent: ErrorPage,
  notFoundComponent: NotFoundPage,
});
